module.exports = __webpack_public_path__ + "img/pets_403_1.b18fd9c9.svg";